import React, { FC } from 'react';
import InformationCard, { SettingFormOptions } from './InformationCard';
import Employee from 'src/interfaces/api/Employee';
import useAuth from 'src/hooks/api/useAuth';

interface Props {
  openToast: (success: boolean, message: string) => void;
  user: Employee;
}

const InformationCardContainer: FC<Props> = (props) => {
  const { fetch } = useAuth();

  const handleSave = async (options: SettingFormOptions) => {
    const { firstname, lastname, confirmPassword, ...params } = options;

    const response = await fetch(`/api/user/${props.user.legacyUserId}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'PATCH',
      body: JSON.stringify(params),
    });

    const json = await response.json();

    if (json.isValid) {
      if (!json.error) {
        props.openToast(true, 'Informations personnelles modifiées !');
      } else {
        props.openToast(false, json.error);
      }
    } else {
      props.openToast(false, 'Erreur modification. Veuillez réessayer');
    }
  };

  return <InformationCard onSave={handleSave} {...props} />;
};

export default InformationCardContainer;
